import axios from "axios";

export default function createAdmin({ email, username, password, role, group }) {
  return new Promise((resolve, reject) => axios
    .post(`/account/system-admin/api/v1/admin`, {
      email, username, password, role_uuid: role, company_group_uuid: group
    })
    .then((response) => resolve(response.data))
    .catch((error) => reject(error.message))
  );
}
